import {NgModule} from '@angular/core';
import {BlgAkaunTsLibComponent} from './blg-akaun-ts-lib.component';


@NgModule({
  declarations: [BlgAkaunTsLibComponent],
  imports: [],
  exports: [BlgAkaunTsLibComponent]
})
export class BlgAkaunTsLibModule {
}
